import { AgColumnDefinition, AgGridColumnType, AgGridExportType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'

export const billingGridInvoiceReceiptsColumnDefs =
    (): Array<AgColumnDefinition> => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('accounting.field.invoiceReceipt'),
            field: 'label',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.client'),
            colId: 'invoice.customer.name',
            field: 'customer.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.generationDate'),
            field: 'generationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.generationResponsible'),
            colId: 'generator.normalizedFullName',
            field: 'generator.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.verificationDate'),
            field: 'verificationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.verificationResponsible'),
            colId: 'verifier.normalizedFullName',
            field: 'verifier.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.deliveryNote', 2),
            field: 'billableDeliveryNoteCount',
            type: AgGridColumnType.NUMBER,
            exportType: AgGridExportType.NUMBER,
            filter: false,
            sortable: false,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.concept', 2),
            field: 'appliedBillableConceptCount',
            type: AgGridColumnType.NUMBER,
            exportType: AgGridExportType.NUMBER,
            filter: false,
            sortable: false,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.total'),
            field: 'realTotalValue',
            type: AgGridColumnType.DECIMAL,
            exportType: AgGridExportType.DOUBLE,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('billing.label.conceptsTotal'),
            field: 'conceptsRealTotalValue',
            type: AgGridColumnType.DECIMAL,
            exportType: AgGridExportType.DOUBLE,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.unit'),
            field: 'invoiceAccountingUnit.symbol',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.externalIdentifier'),
            field: 'externalReference',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.paymentDate'),
            field: 'paymentDate',
            type: AgGridColumnType.DATE,
            exportType: AgGridExportType.DATE,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.paymentMethod'),
            field: 'paymentMethod.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        }
    ]
